import React from "react";
import { Draggable } from "react-beautiful-dnd";
import { dateHelper, dateTzOffset, displayOnlyYear, convertToLocalTime, humanReadableDate } from "../utils/dateHelper";
import { DateTime } from "luxon";

const Task = ({ task, index }) => {
  console.log("task", task);

  const classifyIssue = (arr) => {
    if (arr?.length === 1) {
      switch (arr[0]) {
        case "P0":
          return "Stops me from Doing my work (P0)";
        case "P1":
          return "Delays my work (P1)";
        case "P2":
          return "Minor inconvenience (P2)";
        default:
          return "Invalid input";
      }
    } else {
      return "Invalid input";
    }
  };

  const getLocalDateTime = (isoDateTime) => {
    const localDateTime = convertToLocalTime(isoDateTime);
    const luxonDateTime = DateTime.fromISO(localDateTime, { zone: "utc" });
    const formattedDateTime = luxonDateTime.toFormat("dd LLL yyyy HH:mm");
    return formattedDateTime;
  };

  const adjustedDate = getLocalDateTime(task.created);

  return (
    <Draggable draggableId={task.id} index={index}>
      {(provided) => (
        <div
          className="task"
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          style={{
            padding: "10px",
            borderRadius: "5px",
            marginBottom: "10px",
            height: "auto",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between"
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ fontSize: "14px", fontWeight: "600", color: "#0568bf" }}>
           <a
              href={`https://toorakcapital.atlassian.net/browse/${task.key}`}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#156ab3",
                fontWeight: 600,
                textDecoration: "none",
                cursor: "pointer"
              }}
            >
              {`Ticket : ${task.key}`}
            </a>
            </div>
            <div className="bug">
              <p style={{ fontSize: "10px", margin: "3px 0px 0px 15px", color: "white" }}>
                {task.issueType}
              </p>
            </div>
          </div>
          <div>
            <p style={{ fontSize: "16px", fontWeight: "600" }}>
              {task.summary}
            </p>
          </div>
          <div>
            <p style={{ fontSize: "12px" }}>
              Impact: {classifyIssue(task.label[0])}
            </p>
            <div style={{ fontSize: "12px", whiteSpace: "pre-wrap", wordWrap: "break-word" }}>
              <strong>Description:</strong> {task.description}
            </div>
          </div>
          <div>
            <p style={{ fontSize: "12px", color: "var(--neutral-neutral-600)", fontFamily: "OpenSans" }}>
              {adjustedDate}
            </p>
          </div>
        </div>
      )}
    </Draggable>
  );
};

export default Task;
